var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation core",
      class: { open: _vm.isMobileNavigationOpen },
      attrs: {
        "aria-labelledby": "mobile-navigation-toggler",
        itemscope: "",
        itemtype: "https://schema.org/SiteNavigationElement"
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ]
        },
        [
          _c(
            "ul",
            { staticClass: "breadcrumb d-block px-3 py-0" },
            [
              _c("li", {
                staticClass: "btn-close",
                attrs: {
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                },
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "breadcrumb-item",
                  on: {
                    click: function($event) {
                      return _vm.goTo(-1)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-home",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.breadcrumbs, function(breadcrumb, index) {
                return _c(
                  "li",
                  {
                    staticClass: "breadcrumb-item",
                    on: {
                      click: function($event) {
                        return _vm.goTo(index)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(breadcrumb.name) + "\n      ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" }
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown line16",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            _vm.dataContainer1.parent || null,
                            true
                          )
                        }
                      }
                    },
                    [_vm._m(0)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataContainer1.category &&
              _vm.dataContainer1.category.children &&
              _vm.dataContainer1.category.categoryId == null
                ? _vm._l(_vm.dataContainer1.category.children, function(
                    category,
                    index
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c(
                        "div",
                        {
                          staticClass: "w-100 d-flex",
                          class: category.name,
                          attrs: {
                            "data-index": index,
                            "data-level": category.level
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.getCategoryUrl(category.url),
                                itemprop: "name"
                              }
                            },
                            [_vm._v(_vm._s(category.name))]
                          ),
                          _vm._v(" "),
                          category.children && category.children.length > 0
                            ? _c(
                                "span",
                                {
                                  staticClass: "nav-direction",
                                  on: {
                                    click: function($event) {
                                      return _vm.slideTo(category, false)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-lg fa-caret-right",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  })
                : _vm.dataContainer1.category &&
                  _vm.dataContainer1.category.categoryId &&
                  _vm.dataContainer1.category.categoryId > 0
                ? _vm._l(_vm.dataContainer2.category.children, function(
                    category
                  ) {
                    return category.url
                      ? _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: _vm.getCategoryUrl(category.url) }
                            },
                            [_vm._v(_vm._s(category.details[0].name))]
                          )
                        ])
                      : _vm._e()
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" }
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            _vm.dataContainer2.parent || null,
                            true
                          )
                        }
                      }
                    },
                    [_vm._m(1)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataContainer2.category &&
              _vm.dataContainer2.category.children &&
              _vm.dataContainer2.category.categoryId == null
                ? _vm._l(_vm.dataContainer2.category.children, function(
                    category
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c(
                        "a",
                        { attrs: { href: _vm.getCategoryUrl(category.url) } },
                        [_vm._v(_vm._s(category.name))]
                      ),
                      _vm._v(" "),
                      category.children && category.children.length > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "nav-direction",
                              on: {
                                click: function($event) {
                                  return _vm.slideTo(category, false)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-lg fa-caret-right",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  })
                : _vm.dataContainer2.category &&
                  _vm.dataContainer2.category.categoryId &&
                  _vm.dataContainer2.category.categoryId > 0
                ? _vm._l(_vm.dataContainer2.category.children, function(
                    category
                  ) {
                    return category.url
                      ? _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.getCategoryUrl(category.url),
                                itemprop: "name"
                              }
                            },
                            [_vm._v(_vm._s(category.details[0].name))]
                          )
                        ])
                      : _vm._e()
                  })
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                attrs: {
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                },
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(2)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }